let btns = document.querySelectorAll('[data-careers-btn]');

btns.forEach (btn => {
    btn.addEventListener('click', () => {
        let careersContent = document.querySelectorAll('[data-careers-content]');

        careersContent.forEach(content => {
            content.classList.remove('active');
        });

        let careers = document.querySelector(`[data-careers-content="${btn.getAttribute('data-careers-btn')}"]`);
        careers.classList.add('active');
    });
});

